import React, { Fragment } from "react"

import { PAYMENT_STATUS, CASH_METHOD, MODE_TAKE_AWAY } from "../"
import ItemPrice from "../../ui-components/ItemPrice"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function RecapSection(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { order } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function localizePaymentDesc() {
    if (order.payment.method_name === CASH_METHOD) {
      return I18n.t(CASH_METHOD)
    }

    switch (order.payment?.status) {
      case PAYMENT_STATUS.PREAUTHORIZED:
        return I18n.t("pages.orders.show.stripe.preauthorized_payment")
      case PAYMENT_STATUS.PAID:
        return I18n.t("pages.orders.show.payment_desc", {
          method: I18n.t(order?.payment?.method_name || "empty"),
          price: (order?.payment?.paid_amount_cents / 100).toFixed(2),
          defaultValue: "",
        })
      case PAYMENT_STATUS.REQUIRES_AUTH:
        return I18n.t("pages.orders.show.pending_payment_desc")
      case PAYMENT_STATUS.EXPIRED:
      case PAYMENT_STATUS.FAILED:
        return I18n.t("pages.orders.show.payment_failed_recap")
      default:
        return ""
    }
  }

  function renderLineItem(item) {
    return (
      <div
        key={item.id}
        className={`${style.lineItemContainer} ${style.lineItemMargin}`}
      >
        <span>{item.quantity}</span>
        <div className={style.itemPartsContainer}>
          <span className={style.name}>{item.name}</span>
          {item?.additional_parts?.map((add) => {
            return (
              <span className={style.additionalPartsContainer}>
                <i className="far fa-plus" /> {add.name}
              </span>
            )
          })}
        </div>
        <ItemPrice
          className={style.price}
          originalPriceCents={item.total_original_price}
          priceCents={item.total_price}
        />
      </div>
    )
  }

  function renderLineItems() {
    if (Array.isArray(order.line_items)) {
      order.line_items.map((el) => {
        return renderLineItem(el)
      })
    } else {
      return Object.keys(order.line_items).map((key) => {
        return renderLineItem(order.line_items[key])
      })
    }
  }

  function renderTotalItem(
    title,
    amount,
    originalAmount = null,
    emphasize = false
  ) {
    return (
      <div
        className={`${style.lineItemContainer} ${style.totalItemMargin} ${
          emphasize ? style.redTitle : ""
        }`}
      >
        <span>{title}</span>
        <ItemPrice
          className={emphasize ? style.redPrice : style.price}
          originalPriceCents={originalAmount}
          priceCents={amount}
        />
      </div>
    )
  }

  function renderInfo(title, text) {
    return (
      <div>
        <p className={style.sectionTitle}>{title}</p>
        <span className={style.lineItemContainer}>{text}</span>
        <div className={style.separator}></div>
      </div>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.container}>
      {order.takeaway_order && (
        <Fragment>
          <p className={style.sectionTitle}>{I18n.t("pickup_time")}</p>
          <p className={style.title}>{order.proposed_picking_time}</p>
        </Fragment>
      )}

      {!order.takeaway_order && (
        <Fragment>
          <p className={style.sectionTitle}>
            {order.mode === MODE_TAKE_AWAY
              ? I18n.t("pickup_time")
              : I18n.t("delivery_time")}
          </p>
          <p className={style.title}>
            {order.mode === MODE_TAKE_AWAY
              ? order.start_time
              : `${order.start_time}/${order.end_time}`}
          </p>
        </Fragment>
      )}

      {order?.line_items && renderLineItems()}
      <div className={style.separator}></div>
      {renderTotalItem(I18n.t("subtotal"), order.goods_price_cents)}
      {order.mode !== MODE_TAKE_AWAY &&
        renderTotalItem(
          order.mode === "venue"
            ? I18n.t("delivery_marketplace")
            : I18n.t("delivery_racer"),
          order.delivery_price_cents
        )}
      {!!order.goods_discount_price_cents &&
        renderTotalItem(
          I18n.t("discount_coupon"),
          -order.goods_discount_price_cents
        )}
      {renderTotalItem(
        I18n.t("total"),
        (order.discounted_price_cents || order.total_price_cents),
        null,
        true
      )}

      <div className={style.marginTop}></div>
      {order?.venue?.name &&
        renderInfo(I18n.t("restaurant"), order.venue?.name)}
      {order?.complete_address &&
        renderInfo(I18n.t("address"), order.complete_address)}
      {order?.phone && renderInfo(I18n.t("phone"), order.phone)}
      {order?.delivery_notes &&
        renderInfo(
          I18n.t("pages.orders.show.additional_notes"),
          order.delivery_notes
        )}

      {order?.request_invoice && order?.billing_address && (
        <Fragment>
          <div className={style.marginTop}></div>
          {renderInfo(
            I18n.t("cart_summary.business_name"),
            order?.billing_address?.business_name
          )}
          {renderInfo(
            I18n.t("cart_summary.business_address"),
            order?.billing_address?.business_address
          )}
          {renderInfo(
            I18n.t("cart_summary.invoice_code"),
            order?.billing_address?.business_invoice_code
          )}
          {renderInfo(
            I18n.t("cart_summary.vat_code"),
            order?.billing_address?.vat_code
          )}
          {renderInfo(
            I18n.t("cart_summary.tax_code"),
            order?.billing_address?.tax_code
          )}
        </Fragment>
      )}

      {order?.payment?.method_name && (
        <Fragment>
          <div className={style.marginTop}></div>
          {renderInfo(
            I18n.t("pages.orders.show.payment"),
            localizePaymentDesc()
          )}
        </Fragment>
      )}

      {order?.delivery_receipt && (
        <a href={order?.delivery_receipt_url || "#"} target="_blank">
          {I18n.t("pages.orders.show.download_receipt")}
        </a>
      )}

      <div className={style.marginTop}></div>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default RecapSection
